import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Assurance from './components/Assurance';
import CloudExpertise from './components/CloudExpertise';
import Automation from './components/Automation';
import Security from './components/Security';
import Engagement from './components/Engagement';
import Expertise from './components/Expertise';
import Contact from './components/Contact';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <Services />
      <Assurance />
      <CloudExpertise />
      <Automation />
      <Security />
      <Engagement />
      <Expertise />
      <Contact />
      <Footer />
      <BackToTop />
    </div>
  );
}

export default App;
